export default {"src":"/_next/static/media/fennel.675aca70.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};